<template>
  <div class="container">
    <div class="contacts d-flex">
      <div class="d-flex flex-column">
        <div class="contacts__title">Не знайшов відповіді на запитання?</div>
        <div class="contacts__item d-flex align-center">
          <span>Дзвони</span><a href="tel:0676276251" class="contacts__link ml-a d-inline-b">067 627 62 51</a>
        </div>
        <div class="contacts__item d-flex align-center">
          <span>Пиши</span><a href="mailto:grandpicnic@novaposhta.ua" class="contacts__link ml-a d-inline-b">grandpicnic@novaposhta.ua</a>
        </div>
      </div>
      <img src="./../assets/images/contacts/grand.png" class="contacts__img" alt="GRAND PICNIC NP">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Сontacts'
}
</script>

<style scoped lang="scss">
@use 'sass:math';
@import "../assets/styles/parts/variables";
@import "../assets/styles/parts/mixins";

.container {
  @media (max-width: 1023px) {
    padding: 0;
  }
}
.contacts {
  background: $white;
  border: 1px solid $border-gray;
  border-radius: sm(24);
  flex-direction: column;
  margin-top: sm(40);
  padding: sm(40) sm(24) 0;
  @include _1024 {
    margin-top: sl(80);
    padding: sl(48) sl(64);
    border-radius: sl(24);
    flex-direction: row;
  }
  @include _1920 {
    margin-top: 80px;
    padding: 48px 64px;
    border-right: 24px;
  }
  &__title {
    font-size: sm(18);
    padding-bottom: sm(24);
    @include _1024 {
      padding-bottom: sl(32);
      font-size: sl(32);
      padding-top: sl(16);
    }
    @include _1920 {
      font-size: 32px;
      padding-top: 16px;
      padding-bottom: 32px;
    }
  }
  &__item {
    background: rgba(32, 33, 36, 0.04);
    font-size: sm(16);
    line-height: math.div(22.4, 16);
    padding: sm(16) sm(24);
    flex-direction: column;
    border-radius:  sm(12);
    @media(max-width: 1023px) {
      align-items: flex-start;
    }
    @include _1024 {
      font-size: sl(24);
      flex-direction: row;
      padding: sl(24) sl(32);
      border-radius: sl(12);
    }
    @include _1920 {
      font-size: 24px;
      border-radius: 12px;
      padding: 24px 32px;
    }
    & + & {
      margin-top: sm(16);
      @include _1024 {
        margin-top: sl(16);
      }
      @include _1920 {
        margin-top: 16px;
      }
    }

  }
  &__link {
    color: $text-default;
    outline: none;
    text-decoration: none;
    margin-top: sm(8);
    @media (max-width: 1023px) {
      margin-left: 0;
    }
    @include _1024 {
      margin-top: 0;
    }
  }
  &__img {
    margin: sm(32) auto 0;
    max-width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
    @include _1024 {
      margin-left: sl(233);
      margin-top: 0;
      width: sl(397);
      height: sl(273);
    }
    @include _1920 {
      width: 397px;
      height: 273px;
    }
  }
}

</style>
